// extracted by mini-css-extract-plugin
export default {"card_container":"Card_card_container__q59ZA","flag":"Card_flag__5P-bL","name":"Card_name__Qjf9y","continent":"Card_continent__Lnmzp"};